module.exports = __webpack_public_path__ + "static/media/gallery-add.60f3a5a1.svg";